import AudienceManagerSaga from 'pages/audienceManager/saga';
import AudienceSaga from 'pages/audienceManager/sagas/audiences';
import CustomAudienceManagerSaga from 'pages/customAudiences/saga';
import GroupSaga from 'pages/audienceManager/sagas/groups';
import LoginSaga from 'pages/auth/saga';
import OfferAudiencesSaga from 'pages/offerWallManager/sagas/audiences';
import OfferGroupSaga from 'pages/offerWallManager/sagas/groups';
import OffersSaga from 'pages/offerWallManager/sagas/offers';

import SearchSaga from 'pages/audienceManager/searchSaga';
import { all, fork } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([
    fork(AudienceManagerSaga),
    fork(AudienceSaga),
    fork(CustomAudienceManagerSaga),
    fork(GroupSaga),
    fork(LoginSaga),
    fork(OfferAudiencesSaga),
    fork(OfferGroupSaga),
    fork(OffersSaga),

    fork(SearchSaga),
  ]);
}
